import axios from "../services/axios";


export async function tableDataController ({companyId, moment_table, clientData}) {
    try {
        if (moment_table != 0) {
            const response = await axios.post(`/smartmenu/validate/table`, {
                companyId: companyId,
                table: moment_table,
                clientData: clientData ?? {},
            });

            if (response.status === 200) {
                // GET DATA FROM THE CURRENT LOCATION
                if (response.data.reserved) {
                    return ({message: 'RESERVED'});
                }
            }
        }

        //  MODIFICA OS DADOS DE LOCAL DO CLIENTE
        if (clientData) {
            let array = { ...clientData };
            array.location = moment_table;
            return ({message: 'OK', data: array});
        }

    } catch (error) {
        console.error('ERROR IN TABLE DATA CONTROLLER:', error);
        throw error;
    }

};